import React from 'react';
import classname from 'classnames';

import { BaseWidgetProps } from '../utils/type';

const defaultStyles = {
  width: '100%',
};

interface ContainerInterface extends BaseWidgetProps {
  scrollDirection: string;
}

/**
 * 容器组件
 * @param props
 */
function Container(props: ContainerInterface) {
  const { prefixCls = 'crm-container', className, children, style = {}, scrollDirection = 'y', ...rest } = props;
  let tempStyle = style;

  if (!children) {
    tempStyle = {
      height: '200px',
      backgroundColor: 'rgb(222, 255, 231)',
      ...style,
    };
  }

  const cls = classname({
    [`${prefixCls}`]: true,
    className: true,
    'contaniner-scroll-x': scrollDirection === 'x',
  });

  // if (scrollDirection === 'x') {
  //   tempStyle.overflowX = 'scroll';
  //   tempStyle.whiteSpace = 'nowrap';
  // }
  return <div className={cls} style={{ ...defaultStyles, ...tempStyle }} {...rest}>{children}</div>;
}

export default Container;
